export default "__VITE_ASSET__D3uRiCbc__"